<template>
  <div class="login">
      <div class="loginTop">
        <div class="loginLogo warp">
          <div class="loginImgBox" @click="goToIndex">
            <img src="@/assets/images/dlogo.png" alt="">
          </div>
          <span>欢迎来到恩宝商城</span>
        </div>
      </div>
      <div class="loginCent">
        <div class="loginBox warp">
          <div class="leftImg">
            <img src="@/assets/images/banner.png" alt="">
          </div>
          <div class="loginForm">
            <div class="loginTit" v-text="isRegistered == '1' ? '注册' : '登录'"></div>
            <div class="loginFormBox">
              <div class="inputBox">
                <label>手机号码</label>
                <el-input v-model="userName" placeholder="请输入您的手机号码"></el-input>
              </div>
              <div class="inputBox">
                <label>验证码</label>
                <el-input v-model="verificationCode" placeholder="请输入验证码"></el-input>
                <span v-show="codeShow" class="codeBtn" @click="getCode">获取验证码</span>
                <span v-show="!codeShow" class="codeBtn codeCount">重新获取({{codeCountNum}}s)</span>
              </div>
              <div class="noLogin" :class="{registered: isRegistered === '1'}" >
                <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin">七天免登录</el-checkbox>
                <span @click="registered" v-text="isRegistered === '1' ? '登录' : '用户注册'"></span>
              </div>
              <div class="loginBtn" @click="login" v-text="isRegistered === '1' ? '注册' : '立即登录'">立即登录</div>
            </div>
            <div class="loginProtocol" v-if="isRegistered === '1'">
              <el-checkbox v-model="haveRead"></el-checkbox>
              <span>阅读并同意</span>
              <span @click="readAgreement">《恩宝商城 服务协议》</span>
            </div>
          </div>
        </div>
      </div>
    <el-dialog
      title="服务协议"
      :visible.sync="dialogAgreement"
      width="50%">
      这是服务协议
    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import api from '../../api'
import { listSearchMixin } from '../../config/mixin'
import {mapMutations} from 'vuex'
export default {
  name: 'login',
  mixins: [listSearchMixin],
  data () {
    return {
      userName: '',
      verificationCode: '',
      isNoLogin: false,
      haveRead: false,
      codeShow: true,
      codeCountNum: '',
      dialogAgreement: false,
      isRegistered: '2'
    }
  },
  mounted () {
    if (this.$route.query.type) {
      this.isRegistered = this.$route.query.type
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO' // 修改用户信息
    }),
    getUserInfo () {
      let self = this
      let params = {
        url: api.getUser,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.setUserInfo(res.data)
          self.userInfoData = res.data
          // console.log(res)
        }
      })
    },
    getCode () {
      const TIME_COUNT = 120
      let self = this
      let reg = /^1[13456789]\d{9}$/
      if (!reg.test(self.userName)) {
        self.$message.error('手机号格式错误')
        return
      }
      let params = {
        url: api.vCode + `?phone=${self.userName}`,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          if (!this.timer) {
            this.codeCountNum = TIME_COUNT
            this.codeShow = false
            this.timer = setInterval(() => {
              if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
                this.codeCountNum--
              } else {
                this.codeShow = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
          this.$message.success('验证码获取成功')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 阅读协议
    readAgreement () {
      this.dialogAgreement = true
    },
    goToIndex () {
      this.$router.push({path: '/'})
    },
    login () {
      let self = this
      let reg = /^1[13456789]\d{9}$/
      if (!reg.test(self.userName)) {
        self.$message({
          message: '手机号码格式错误'
        })
        return
      }
      if (self.verificationCode === '') {
        self.$message({
          message: '请输入验证码'
        })
        return
      }
      if (self.isRegistered === '2') {
        this.getLogin()
      } else if (this.haveRead) {
        this.getLogin()
      } else {
        this.$message.warning('请阅读并同意服务协议')
      }
    },
    getLogin () {
      let self = this
      let params = {
        url: api.login,
        method: 'POST',
        data: {
          phone: self.userName,
          verificationCode: self.verificationCode,
          type: self.isRegistered
        }
      }
      self.sendReq(params, (res) => {
        // console.log(res)
        if (res.code === '200') {
          if (self.isNoLogin) {
            Cookie.set('token', res.data.token, { expires: 7 })
          } else {
            Cookie.set('token', res.data.token, { expires: 1 })
          }
          this.getUserInfo()
          this.$message.success('登录成功')
          this.$router.push({path: '/'})
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    registered () {
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
      this.userName = ''
      this.verificationCode = ''
      if (this.isRegistered === '1') {
        this.isRegistered = '2'
      } else {
        this.isRegistered = '1'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .login {
    height: 100vh;
    display: flex;
    flex-direction: column;
    min-height: 768px;
    .loginTop {
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
      position: relative;
      z-index: 999;
      flex-shrink: 0;
      .loginLogo {
        display: flex;
        align-items: center;
        height: 88px;
        img {
          width: 180px;
          margin-right: 30px;
        }
        span {
          font-size: 18px;
          color: $fontColor;
        }
        .loginImgBox {
          width: 180px;
          height: 40px;
          align-items: center;
          display: flex;
          margin-right: 20px;
          cursor: pointer;
          img {
            width: 100%;
          }
        }
      }
    }
    .loginCent {
      background: url('../../assets/images/beijing.png') no-repeat;
      flex-grow: 1;
      background-size: cover;
      display: flex;
      align-items: center;
      .loginBox {
        display: flex;
        align-items: center;
        position: relative;
      }
      .leftImg {
        width: 760px;
        height: 490px;
      }
      .loginForm {
        width: 540px;
        background: #ffffff;
        box-shadow: 0px 15px 14px 2px rgba(162, 87, 20, 0.15);
        border-radius: 20px;
        position: absolute;
        right: 0;
        .loginTit {
          height: 50px;
          display: flex;
          align-items: center;
          font-size: 30px;
          color: $mainColor;
          width: 100%;
          justify-content: center;
          margin: 70px 0;
          &:before {
            content: '';
            height: 2px;
            width: 98px;
            display: block;
            background: url("../../assets/images/dzuo.png") no-repeat;
            margin-right: 27px;
          }
          &:after {
            content: '';
            height: 2px;
            width: 98px;
            display: block;
            background: url("../../assets/images/dyou.png") no-repeat;
            margin-left: 27px;
          }
        }
        .loginFormBox {
          padding: 0 60px;
          .inputBox {
            position: relative;
            label {
              color: $fontColor;
              font-size: 18px;
              font-weight: 500;
            }
            >>> .el-input__inner {
              height: 64px;
              border: none;
              border-bottom: 1px solid #EEEEEE;
              font-size: 20px;
              color: #666666;
              padding-left: 0;
            }
            &:nth-child(2) {
              margin: 60px 0 20px 0;
            }
            .codeBtn {
              width: 140px;
              height: 54px;
              background: #EEEEEE;
              border-radius: 4px;
              display: block;
              line-height: 54px;
              text-align: center;
              position: absolute;
              right: 0;
              bottom: 10px;
              cursor: pointer;
            }
            .codeCount {
              color: #999999;
            }
          }
          .noLogin {
            color: #333333;
            font-size: 18px;
            margin:20px 0 60px 0;
            height: 30px;
            align-items: center;
            display: flex;
            justify-content: space-between;
            >>> .el-checkbox__label {
              font-size: 16px;
              color: #333333;
              font-weight: 400;
            }
            span {
              cursor: pointer;
              font-size: 16px;
              text-decoration: underline;
              color: #666666;
            }
          }
          .registered {
            justify-content: flex-end;
          }
          .loginBtn {
            width: 100%;
            background: $mainColor;
            height: 60px;
            line-height: 60px;
            border-radius: 27px;
            text-align: center;
            font-size: 20px;
            color: #ffffff;
            margin-bottom: 60px;
            cursor: pointer;
          }
        }
        .loginProtocol {
          padding: 0 60px;
          display: flex;
          align-items: center;
          height: 80px;
          line-height: 80px;
          border-top: 1px solid #EEEEEE;
          span {
            margin-left: 10px;
          }
          span:nth-child(3) {
            color: #426BEA;
            cursor: pointer;
          }
        }
        >>> .el-checkbox__inner {
          width: 20px;
          height: 20px;
          &:after {
            height: 10px;
            left: 7px;
            width: 4px;
          }
        }
      }
    }
    >>> .el-dialog__body {
      max-height: 500px;
      min-height: 300px;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue